import { TOOLBAR_DATA_HOOK } from '../../data-hooks';

export const getToolbarElement = (dataHook: string) =>
  document.querySelector(
    `[data-hook~=${TOOLBAR_DATA_HOOK}] [data-hook~=${dataHook}]`
  ) as HTMLElement | null;
